module.exports = __webpack_public_path__ + "img/icon1.a7a6ccda.png";